import { createContext, type ReactNode } from 'react'
import type { ButtonVariant } from './Button'
import type { ModalProps } from './Modal'

export interface ConfirmOptions {
  title?: string
  message: ReactNode
  confirmLabel?: string
  cancelLabel?: string
  /** 'danger' per azioni distruttive (elimina...), 'primary' per conferme neutre. Default: 'danger'. */
  variant?: Extract<ButtonVariant, 'danger' | 'primary'>
  /** Larghezza della conferma, utile quando il messaggio contiene dettagli strutturati. */
  size?: ModalProps['size']
}

export interface AlertOptions {
  title?: string
  message: ReactNode
  okLabel?: string
}

export const ConfirmContext = createContext<((options: ConfirmOptions | string) => Promise<boolean>) | null>(null)
export const AlertContext = createContext<((options: AlertOptions | string) => Promise<void>) | null>(null)
